"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function DropdownButton(props) {
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    anchor = _useState2[0],
    setAnchor = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    menuProps = _useState4[0],
    setMenuProps = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    menuItems = _useState6[0],
    setMenuItems = _useState6[1];
  var children = props.children,
    menuClassName = props.menuClassName,
    label = props.label,
    title = props.title,
    onMenuClose = props.onMenuClose;
  var open = Boolean(anchor);

  /* eslint-disable  eslint-parser is not able to parse this */
  var isChild = function isChild(children) {
    return /*#__PURE__*/_react.default.isValidElement(children);
  };
  /* eslint-enable */

  (0, _react.useEffect)(function () {
    if (isChild(children)) {
      setMenuProps(children.props);
      setMenuItems(children.props.children);
    }
  }, [children]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    "aria-controls": open ? 'button-dropdown' : undefined,
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    disableElevation: true,
    onClick: function onClick(e) {
      return setAnchor(e.currentTarget);
    },
    endIcon: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      size: "xs",
      icon: _freeSolidSvgIcons.faCaretDown
    })
  }, props), label || title), /*#__PURE__*/_react.default.createElement(_Menu.default, (0, _extends2.default)({
    className: menuClassName,
    anchorEl: anchor,
    open: open,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    onClose: function onClose() {
      if (onMenuClose) {
        onMenuClose();
      }
      setAnchor(null);
    }
  }, menuProps), menuItems));
}
DropdownButton.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]).isRequired,
  title: _propTypes.default.string,
  /** ReactElements may be passed as label when string is insufficient */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  onMenuClose: _propTypes.default.func
};
DropdownButton.defaultProps = {
  label: null,
  title: '',
  onMenuClose: null
};
var _default = DropdownButton;
exports.default = _default;